export default "/images/3a758cf96fbd75a33b56b72be2d7f9d7.avif";